import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { GridTile } from 'material-ui/GridList';
import { Row, Col } from 'react-flexbox-grid';
import PropTypes from 'prop-types';
import ImagePictureAsPdfIcon from 'material-ui/svg-icons/image/picture-as-pdf';
import CameraIcon from 'material-ui/svg-icons/image/camera';
import FileIcon from 'material-ui/svg-icons/editor/insert-drive-file';
import BrokenImageIcon from 'material-ui/svg-icons/image/broken-image';
import { getImagePreviewUrl, getFilePreviewUrl } from '../services/FileStackService';
import IconButton from 'material-ui/IconButton';
import CheckCircle from 'material-ui/svg-icons/action/check-circle';
import ImagePanoramaFishEye from 'material-ui/svg-icons/image/panorama-fish-eye';

function getDefaultIconByFileExtension(ext) {
  ext = String(ext).toLowerCase();

  if (ext === 'pdf') {
    return <ImagePictureAsPdfIcon />;
  }

  if (ext === 'jpg' || ext === 'jpeg' || ext === 'png' || ext === 'gif') {
    return <CameraIcon />;
  }

  if (ext === 'ppt' || ext === 'pptx' || ext === 'txt' || ext === 'doc' || ext === 'docx' || ext === 'xls' || ext === 'xlsx') {
    return <FileIcon />;
  }

  return <BrokenImageIcon />;
}

export default class DocumentPreview extends Component {

  static propTypes = {
    renderAsGridTile: PropTypes.bool
  };

  static defaultPropTypes = {
    renderAsGridTile: false
  };

  _handlePressTile = (document) => {
    const {handleFileSelect} = this.props;

    if(handleFileSelect){
        handleFileSelect(document)
    }
  };

  _renderTileActionButton = (document) => {
      const {selectedFiles} = this.props;
      const selected = selectedFiles.indexOf(document.filestackId) > -1;
      let show = selected;
      let colors = {
          circleColor: "rgba(177, 177, 177, 0.9)",
          hover: "rgba(255, 255, 255, 1)"
      };

      if(selected){
        colors.circleColor = "#4285f4";
        colors.hover = "#4285f4";
      }

      let icon = (
          <CheckCircle
              color={colors.circleColor}
              hoverColor={colors.hover}
          />
      );

      if(!selected && selectedFiles.length > 0){
        show = true;
        // icon = (
        //     <ImagePanoramaFishEye
        //         color={colors.circleColor}
        //     />
        // )
      }

      return (
          <IconButton
              onClick={() => this._handlePressTile(document)}
              className={`tile-selection-item ${show ? 'tile-selection-item-selected': ''}`}
          >
              {icon}
          </IconButton>
      );
  };

  _handleTileLink = (e) => {
      const { document, selectedFiles } = this.props;
      const selectMode = selectedFiles.length > 0;

      if(selectMode){
          this._handlePressTile(document);

          e.stopPropagation();
          e.nativeEvent.stopImmediatePropagation();
          e.preventDefault();
      }

  };

  render() {
    const { document, renderAsGridTile, selectedFiles } = this.props;
    const selected = selectedFiles.indexOf(document.filestackId) > -1;
    const selectMode = !selected && selectedFiles.length > 0;

    const name = document.name || '';
    const filenameParts = name.split('.');
    const fileExtension = filenameParts.pop();
    const fileBasename = filenameParts.join('.');
    const imageSrc = document.type === 'photo'
      ? getImagePreviewUrl(document.filestackId, 300, 300)
      : getFilePreviewUrl(document.filestackId, 300, 300);
    const previewStyle = { backgroundImage: `url(${imageSrc})` };

    if (renderAsGridTile) {
      let title;

      if (fileBasename.length > 0) {
        title = (
          <div className="filename" title={document.name}>
            <span className="basename">{fileBasename}</span>
            <span className="extension">.{fileExtension}</span>
          </div>
        );
      }

        return (
            <GridTile
                key={`document-${document.id}`}
                title={' '}
                actionIcon={this._renderTileActionButton(document)}
                actionPosition="left"
                titlePosition="top"
                titleBackground={`${selectMode ? "linear-gradient(to bottom, rgba(0,0,0,0.7) 0%,rgba(0,0,0,0.3) 70%,rgba(0,0,0,0) 100%)" : "rgba(0,0,0,0)"}`}
                className={`document-tile ${selected ? 'document-tile-selected': ''}`}
                // title={title}
            >
                <Link onClick={this._handleTileLink} to={`/details/${this.props.document.projectId}/${this.props.document.id}`} target="_blank">
                    <div className="placeholder">
                        <div className="icon">{getDefaultIconByFileExtension(fileExtension)}</div>
                        <div className="image" style={previewStyle}/>
                    </div>
                    <div className="title">
                        {title}
                    </div>
                </Link>
            </GridTile>
        );
    }

    return (
      <Col xs={6} sm={4} md={2} lg={2} className="preview text-center">
        <Link to={`/details/${this.props.document.projectId}/${this.props.document.id}`} target="_blank">
          <div className="preview-image placeholder">
            <div style={previewStyle} />
          </div>
        </Link>
        <Row className="file-name">
          <Col xs={12}>
            <div className="file-name-wrapper">
              <span>{fileBasename}</span>
            </div>
            <span className="file-extension" data-extension={fileExtension} />
          </Col>
        </Row>
      </Col>
    );
  }
}
